import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  input: {
    '& ::placeholder': {
      opacity: 0.6,
    },
  },
  radio: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    rowGap: '16px',
  },
  botoesFormulario: {
    marginTop: theme.spacing(2),
  },
}))
